module.exports = __webpack_public_path__ + "static/media/tree-wt.0fe7735c.svg";